// extracted by mini-css-extract-plugin
export default {"headerContainer":"JKhjIEU0pTloAoj1Zedg","stickable":"YkCHNixmfgJY0wvjNkhD","placeHolderShimmer":"d_umCp0nejeitBnhj34Q"};